import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
    position: relative;
    width: 100%;
    max-width: 80%;
    margin: 10px auto 20px auto;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin: 10px auto 30px auto;
        max-width: 75%;
    }
`;

export const CollectionAsset = styled(motion.div)<{ $stackOrder: number }>`
    position: relative;
    width: 100%;
    height: 100%;
    aspect-ratio: 1/1;

    border-radius: 10px;
    background-color: #898888;
    overflow: hidden;

    transition: transform 200ms ease;

    ${({ $stackOrder }) => {
        if ($stackOrder === 2) {
            return css`
                z-index: 2;
                filter: drop-shadow(0 0 24px rgba(0, 0, 0, 0.55));
                transform-origin: center center;

                ${Wrapper}:hover & {
                    transform: scale(1.15) translateY(12px);
                }
            `;
        }
        if ($stackOrder === 1) {
            return css`
                z-index: 1;
                position: absolute;
                top: 0;
                left: 0;
                transform: rotate(-7deg) translateY(14px) translateX(-16px) scale(0.93);
                filter: drop-shadow(0 0 14px rgba(0, 0, 0, 0.3));
                background-color: #6e6d6d;

                @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
                    transform: rotate(-7deg) translateY(20px) translateX(-22px) scale(0.93);
                }
            `;
        }
        if ($stackOrder === 0) {
            return css`
                z-index: 0;
                position: absolute;
                top: 0;
                left: 0;
                transform: rotate(7deg) translateY(14px) translateX(16px) scale(0.93);
                filter: drop-shadow(0 0 14px rgba(0, 0, 0, 0.3));
                background-color: #525252;

                @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
                    transform: rotate(7deg) translateY(20px) translateX(22px) scale(0.93);
                }
            `;
        }
    }}
`;

export const SingleWrapper = styled.div<{ $disabled?: boolean }>`
    border-radius: 6px;
    overflow: hidden;
    width: 100%;
    position: relative;

    aspect-ratio: 1 / 1;

    background-color: rgba(0, 0, 0, 0.15);

    &:hover {
        cursor: ${({ $disabled }) => ($disabled ? 'auto' : 'pointer')};
    }
`;
